import { any, func, string, object } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { getTemplateName } from "../../utils";
import { getCategoryAndSubCategory } from "../../../ga-utils";

class SearchBoxBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: this.props.initValue || "",
    };
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.state.query) {
      try {
        window.dataLayer = window.dataLayer || [];
        const pageType = get(this.props, ["pageType"], "");
        const searchType = get(this.props, ["searchType"], "");
        const config = get(this.props, ["config"], "");
        const fromLocation = get(this.props, ["fromLocation"], "");
        let categoryInfo = getCategoryAndSubCategory(window.location, pageType, config, fromLocation);
        const templateName = pageType === "story-page" ? getTemplateName(fromLocation?.["story-template"]) : getTemplateName(pageType);

        const dataLayerEvent = {
          event: "dl_search",
          search_term: this.state.query?.toLowerCase(),
          search_type: searchType,
          category: categoryInfo?.category,
          sub_category: categoryInfo?.subCategory,
          content_id: categoryInfo?.contentId,
          template_name: templateName,
          platform: window.innerWidth >= 768 ? "desktop" : "mobile",
          eventCallback: () => {
            this.props.navigateTo(`/search?q=${encodeURIComponent(this.state.query)}`);
          },
        };

        window.dataLayer.push(dataLayerEvent);
      } catch (error) {
        console.error("Error tracking search:", error);
        this.props.navigateTo(`/search?q=${encodeURIComponent(this.state.query)}`);
      }
    }
    this.props.onSubmitHandler && this.props.onSubmitHandler(this.state.query);
  }

  keyPress(e) {
    if (e.keyCode === 27) this.props.onEscape && this.props.onEscape();
  }

  focus() {
    this.textInput && this.textInput.focus();
  }

  static defaultTemplate({ children }) {
    return children;
  }

  render() {
    const Render = this.props.template || this.defaultTemplate;
    return (
      <form
        role="search"
        action="/search"
        onSubmit={(e) => this.onSubmit(e)}
        className={this.props.className}
        ref={this.props.formRef}
      >
        <Render>
          <input
            type="search"
            name="q"
            placeholder={this.props.placeholder}
            value={this.state.query}
            onChange={(e) => this.setState({ query: e.target.value })}
            className={this.props.inputClassName}
            id={this.props.inputId}
            ref={(input) => (this.textInput = input)}
            onKeyDown={(e) => this.keyPress(e)}
          />
        </Render>
      </form>
    );
  }
}

SearchBoxBase.propTypes = {
  initValue: string,
  placeholder: string,
  className: string,
  formRef: any,
  inputClassName: string,
  inputId: string,
  template: any.isRequired,
  onSubmitHandler: func,
  navigateTo: func.isRequired,
  onEscape: func,
  searchType: string,
  pageType: string,
  fromLocation: object,
  config: object,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  navigateTo: function (url) {
    global.app.navigateToPage(dispatch, url);
  },
});

export const SearchBox = connect(mapStateToProps, mapDispatchToProps)(SearchBoxBase);
